var Mock = require('mockjs')
//import Mock from 'mockjs'
var data = Mock.mock({
   "status": 0,
   "list": {
    'datalist|12-15': [{
      'title': "@cword(15, 30)",
      'src': "http://pic2.ooopic.com/dreamstime/video/39/43/77/39437741.jpg",
      'url': "@url()"
    }]
  }
})

module.exports = {
 	data 
 }



// WEBPACK FOOTER //
// ./src/mock/messege.js